import { render, staticRenderFns } from "./ConfirmCompleteTaskModal.vue?vue&type=template&id=f9a28f6c"
import script from "./ConfirmCompleteTaskModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmCompleteTaskModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports